module.exports = __webpack_public_path__ + "static/nutrition-icon-fc01f52fa5c6a61d039a87f69d54d0be.svg";